// A light, translucent screen so the page stays readable while it loads, instead of a black backdrop.
export const LOADING_OVERLAY_BACKGROUND = "rgba(255, 255, 255, 0.72)";
export const LOADING_OVERLAY_SPINNER_SIZE_PX = 40;
